export const SET_AUCTION = "SET_AUCTION";
export const setAuction = auction => ({
  type: SET_AUCTION,
  data: auction
});



// WEBPACK FOOTER //
// ./src/redux/actions/controllers/auction.js